window.UserReport = {
    users: {},
    tasks: [],
    startTime: '',
    endTime: '',
    sortTasksBy: 'id',
    emptyProfileImageUrl: 'data:image/gif;base64,R0lGODlhAQABAPAAAAGTz////yH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==',
    textFilter: '',

    currentPage: 0,
    recordsPerPage: 10,

    xhr: null,

    initialize: function() {
        $('#startTime').val(moment().subtract(1, 'week').format('MM/DD/YYYY'));
        $('#endTime').val(moment().format('MM/DD/YYYY'));

        $('#startTime, #endTime').on('change', function() {
            UserReport.refresh();
        });

        $('#downloadCsv').off('click').on('click', function() {
            UserReport.downloadCsv();
        });

        $('.sort-by a[data-value]').off('click').on('click', function() {
            // If the user is selecting an already-selected option, clear it
            if ($(this).parent().is('.disabled')) {
                $(this).parent().removeClass('disabled');
                $('#sortBy').css('font-weight', '');
                UserReport.sortTasks('id');

                return true;
            }

            $('.sort-by li.disabled').removeClass('disabled');
            $(this).parent().addClass('disabled');

            $('#sortBy').css('font-weight', 'bold');

            UserReport.sortTasks($(this).attr('data-value'));
        });

        $('#only-show-follow-ups, #show-unassigned').off('click').on('click', function() {
            UserReport.render();
        });

        UserReport.refresh();
    },

    applyTextFilter: function(filterText) {
        UserReport.textFilter = filterText.replace(/\s+/g, ' ').trim().toLowerCase();
        UserReport.render();
    },

    sortTasks: function(sortBy) {
        if (! sortBy) {
            sortBy = this.sortRowsBy;
        } else {
            this.sortRowsBy = sortBy;
        }

        var sortMethods = {
            'assignee-ascending': function(a, b) {
                var aName = '';
                var bName = '';
                if (UserReport.users[a.assigned_to]) {
                    aName = UserReport.users[a.assigned_to].f_name + ' ' + UserReport.users[a.assigned_to].l_name;
                }
                if (UserReport.users[b.assigned_to]) {
                    bName = UserReport.users[b.assigned_to].f_name + ' ' + UserReport.users[b.assigned_to].l_name;
                }

                if (aName > bName) {
                    return 1;
                }
                if (aName < bName) {
                    return -1;
                }
                return 0;
            },
            'assignee-descending': function(a, b) {
                var aName = '';
                var bName = '';
                if (UserReport.users[a.assigned_to]) {
                    aName = UserReport.users[a.assigned_to].f_name + ' ' + UserReport.users[a.assigned_to].l_name;
                }
                if (UserReport.users[b.assigned_to]) {
                    bName = UserReport.users[b.assigned_to].f_name + ' ' + UserReport.users[b.assigned_to].l_name;
                }

                if (aName > bName) {
                    return -1;
                }
                if (aName < bName) {
                    return 1;
                }
                return 0;
            },
            'date-created-ascending': function(a, b) {
                if (moment(a.created_on) > moment(b.created_on)) {
                    return 1;
                }
                if (moment(a.created_on) < moment(b.created_on)) {
                    return -1;
                }
                return 0;
            },
            'date-created-descending': function(a, b) {
                if (moment(a.created_on) > moment(b.created_on)) {
                    return -1;
                }
                if (moment(a.created_on) < moment(b.created_on)) {
                    return 1;
                }
                return 0;
            },
            'id': function(a, b) {
                var aId = parseInt(a.id);
                var bId = parseInt(b.id);

                if (aId > bId) {
                    return 1;
                }
                if (aId < bId) {
                    return -1;
                }
                return 0;
            }
        };

        if (! sortMethods[sortBy]) {
            sortBy = 'id';
        }

        this.tasks.sort(sortMethods[sortBy]);
        UserReport.renderRows();
    },

    setTimes: function(startTime, endTime) {
        this.startTime = startTime;
        this.endTime = endTime;

        $('#startTime').val(this.datetimeToString(startTime));
        $('#endTime').val(this.datetimeToString(endTime));
    },

    refresh: function() {
        if (UserReport.xhr) {
            UserReport.xhr.abort();
        }

        UserReport.xhr = $.ajax({
            url: '/organization/reports/user-follow-up-report-json',
            type: 'GET',
            data: {
                start_time: UserReport.stringToDatetime($('#startTime').val()),
                end_time: UserReport.stringToDatetime($('#endTime').val())
            },
            dataType: 'json',
            success: function(data) {
                if (data.emptyProfileImageUrl) {
                    UserReport.emptyProfileImageUrl = data.emptyProfileImageUrl;
                }

                UserReport.tasks = data.tasks;
                UserReport.updateUsers(data.users);
                UserReport.setTimes(data.startTime, data.endTime);

                UserReport.currentPage = 0;

                UserReport.sortTasks();
                UserReport.render();
            },
            error: function(jqXHR, textStatus, errorThrown) {
                if (errorThrown == 'abort') {
                    return true;
                }

                if (! errorThrown || errorThrown.length == 0) {
                    errorThrown = '<em>Unknown issue</em>';
                }

                var errorHtml =
                    '<p class="text-center no-records-message">Error: ' + errorThrown + '. ' +
                    '<a href="javascript:UserReport.refresh();">Click here to try again</a></p>';
                $('#rows').html(errorHtml);
            }
        });
    },

    getSelectedUserIds: function() {
        var ids = [];

        $('.filters.dropdown-menu input[id^="assignee-"]:checked').each(function() {
            ids.push($(this).val());
        });

        return ids;
    },

    updateUsers: function(users) {
        for (var i in this.users) {
            this.users[i].checked = false;
        }

        for (var i in users) {
            if (! users[i].user_id) {
                continue;
            }

            var userId = users[i].user_id;
            users[i].checked = true;
            this.users[userId] = users[i];
        }

        this.updateUserTaskCounts();
        this.dropUntaskedUsers();
        this.updateAssigneeDropdown();
    },

    updateAssigneeDropdown: function() {
        var users = UserReport.users;
        var isFiltered = $('#only-show-follow-ups:checked').length > 0;

        var menu = $('.filters.dropdown-menu');
        var dropdown = menu.find('.dropdown-header.assignees');
        dropdown.nextAll('li').remove();

        for (var i in users) {
            if (users[i].totalTasks === 0 || (isFiltered && users[i].totalFollowUpTasks === 0)) {
                continue;
            }

            var userName = (users[i].f_name + ' ' + users[i].l_name).trim();
            var userTaskCount = isFiltered ? users[i].totalFollowUpTasks : users[i].totalTasks;

            var listItem = '<li class="assignee"><input type="checkbox" id="assignee-' + i + '" value="' + i + '" ' +
                (users[i].checked ? 'checked="checked"' : '') + '> ' +
                '<label for="assignee-' + i + '">' + userName + ' (' + userTaskCount + ')</label></li>';

            dropdown.after(listItem);
        }

        var listItems = menu.children('li.assignee').get();
        listItems.sort(function(a, b) {
           return $(a).text().toUpperCase().localeCompare($(b).text().toUpperCase());
        })
        $.each(listItems, function(idx, item) {
            menu.append(item);
        });

        menu.find('input[type="checkbox"]').off('change').on('change', function(e) {
            if ($(this).attr('id').match(/^assignee-\d+$/)) {
                UserReport.users[$(this).val()].checked = $(this).is(':checked');
            }
            UserReport.render();
        });

        menu.off('click').on('click', function(e) {
            e.stopPropagation();
        });
    },

    updateUserTaskCounts: function() {
        for (var i in UserReport.users) {
            UserReport.users[i].totalFollowUpTasks = 0;
            UserReport.users[i].totalTasks = 0;
        }

        for (var i in UserReport.tasks) {
            if (! UserReport.tasks[i].assigned_to) {
                continue;
            }

            var userId = UserReport.tasks[i].assigned_to;
            if (! UserReport.users[userId]) {
                continue;
            }

            UserReport.users[userId].totalTasks++;
            if (UserReport.tasks[i].title.match(/^Follow up with /)) {
                UserReport.users[userId].totalFollowUpTasks++;
            }
        }
    },

    dropUntaskedUsers: function() {
        for (var i in UserReport.users) {
            if (UserReport.users[i].totalTasks === 0) {
                delete UserReport.users[i];
            }
        }
    },

    render: function() {
        UserReport.renderRows();
        UserReport.renderGraph();
        UserReport.updateAssigneeDropdown();
    },

    getFilteredTasks: function() {
        var tasks = UserReport.tasks;
        var filteredTasks = [];
        var userRows = UserReport.getSelectedUserIds();
        var onlyShowFilteredTasks = $('#only-show-follow-ups:checked').length > 0;
        var showUnassigned = $('#show-unassigned:checked').length > 0;

        if (showUnassigned) {
            userRows.push('0');
        }

        for(var i=0; i<tasks.length; i++) {
            if (onlyShowFilteredTasks && ! tasks[i].title.match(/^Follow up with /)) {
                continue;
            }

            if (userRows.indexOf(tasks[i].assigned_to) < 0) {
                continue;
            }

            if (! UserReport.isTaskFilteredByText(tasks[i], UserReport.textFilter)) {
                continue;
            }

            filteredTasks.push(tasks[i]);
        }

        return filteredTasks;
    },

    isTaskFilteredByText: function(task, filterText) {
        if (filterText.length == 0) {
            return true;
        }

        var assigneeName = (task.assigned_to_f_name ? task.assigned_to_f_name : '') + ' ' + (task.assigned_to_l_name ? task.assigned_to_l_name : '');
        if (assigneeName.toLowerCase().match(filterText)) {
            return true;
        }

        var creatorName = (task.creator_to_f_name ? task.creator_to_f_name : '') + ' ' + (task.creator_to_l_name ? task.creator_to_l_name : '');
        if (creatorName.toLowerCase().match(filterText)) {
            return true;
        }

        var leadName = (task.f_name ? task.f_name : '') + ' ' + (task.l_name ? task.l_name : '');
        if (leadName.toLowerCase().match(filterText)) {
            return true;
        }

        if (task.email && task.email.toLowerCase().match(filterText)) {
            return true;
        }

        var filterNumbers = filterText.replace(/\D+/g, '');
        if (filterNumbers.length === 0) {
            return false;
        }

        if (task.phone && task.phone.replace(/\D+/g, '').match(filterNumbers)) {
            return true;
        }

        if (task.phone_cell && task.phone_cell.replace(/\D+/g, '').match(filterNumbers)) {
            return true;
        }

        return false;
    },

    getTotalPageCount: function() {
        var pageCount = Math.ceil(UserReport.getFilteredTasks().length / UserReport.recordsPerPage);
        return ! isNaN(pageCount) && pageCount > 0 ? pageCount : 1;
    },

    renderRows: function() {
        var tasks = UserReport.getFilteredTasks();
        var htmlEntries = [];

        if (tasks.length === 0) {
            UserReport.showRowRenderingError();
            return false;
        }

        var displayedTasks = [];
        var pageStart = UserReport.recordsPerPage * UserReport.currentPage;
        var pageEnd = pageStart + UserReport.recordsPerPage;

        for (var i=pageStart; i<tasks.length && i<pageEnd; i++) {
            displayedTasks.push(tasks[i]);
        }

        if (displayedTasks.length == 0 && UserReport.currentPage > 0) {
            UserReport.currentPage = 0;
            UserReport.renderRows();
            return false;
        }

        UserReport.updatePagination(tasks.length);

        for (var i=0; i<displayedTasks.length && i<UserReport.recordsPerPage; i++) {
            htmlEntries.push(UserReport.generateRowHtmlForTask(displayedTasks[i]));
        }

        $('#rows').html(htmlEntries.join("\n"));

        UserReport.attachEventsToRows();
    },

    showRowRenderingError: function() {
        var message = 'No records available';
        if (moment($('#startTime').val()) > moment($('#endTime').val())) {
            message = 'Your start time is greater than your end time. Please consider changing them around';
        }
        $('#rows').html('<p class="text-center no-records-message">' + message + '</p>');
    },

    generateRowHtmlForTask: function(t) {
        var taskHtml;

        var taskStatus = 'not-completed';
        if (t.completed == '1') {
            taskStatus = 'completed';
        } else if (t.follow_up_date != '') {
            taskStatus = moment(t.follow_up_date) <= moment() ? 'overdue' : 'not-completed';
        }

        var userName = ((t.assigned_to_f_name ? t.assigned_to_f_name : '') + ' ' + (t.assigned_to_l_name ? t.assigned_to_l_name : '')).trim();
        if (userName.length === 0) {
            userName = 'Nobody';
        }

        var userProfileImage = UserReport.emptyProfileImageUrl;
        if (UserReport.users[t.assigned_to]) {
            userProfileImage = UserReport.users[t.assigned_to].profile_image_url;
        }

        // Define the user image. If a profile image doesn't load, then it will fall back to the TE logo's blue color
        var userImageHtml = '<img src="' + userProfileImage + '" ' +
            'class="user" title="Assigned to ' + userName + '" width="30" height="30" ' +
            'onerror="this.src=\'' + UserReport.emptyProfileImageUrl + '\'">';

        var taskTimeHtml = '';
        var taskCreatedHtml = 'title="Task created at ' + t.created_on + '"><i class="fa fa-plus"></i> ' + moment(t.created_on).format('M/D/YY');
        if (t.completed == '0') {
            if (t.follow_up_date == '') {
                taskTimeHtml = '<div class="created_on" ' + taskCreatedHtml + '</div>';
            } else {
                taskTimeHtml = '<div class="times"><span ' + taskCreatedHtml + '</span><br />' +
                    '<span title="Follow Up Date is ' + t.follow_up_date + '"><i class="fa fa-clock-o"></i> ' + moment(t.follow_up_date).format('M/D/YY') + '</span></div>';
            }
        } else {
            taskTimeHtml = '<div class="times"><span ' + taskCreatedHtml + '</span><br />' +
                '<span title="Task completed on ' + t.modified_on + '"><i class="fa fa-check"></i> ' + moment(t.modified_on).format('M/D/YY') + '</span></div>';
        }

        var taskHtmlHeader = '<div class="col-md-9"><h4>' + userImageHtml + ' ' + t.id + ': ' + (t.title.length ? t.title : '<em>Untitled Task</em>') + '</h4></div>' +
            '<div class="col-md-2">' + taskTimeHtml + '</div>' +
            '<div class="col-md-1"><button class="btn btn-sm btn-white expand pull-right"><span class="caret"></span></button></div>';

        var createdByName = ((t.creator_f_name ? t.creator_f_name : '') + ' ' + (t.creator_l_name ? t.creator_l_name : '')).trim();
        if (! createdByName.length) {
            createdByName = '<em>Unknown</em>';
        }

        var userLink;
        if (parseInt(t.assigned_to) === 0) {
            userLink = '<em>Unassigned</em>';
        } else {
            userLink = '<a href="/organization/user/view/' + t.assigned_to + '">' + userName + '</a>';
        }
        var leadDetails = UserReport.getLeadHtmlFromTask(t);

        var taskHtmlBody = '<div class="col-md-12 body"><div class="row"><div class="col-md-12">' +
            '<h5>Details</h5><table class="table table-bordered table-striped well">' +
            '<tr><th>Assigned To</th><td>' + userLink + '</td></tr>' +
            '<tr><th>Lead</th><td>' + leadDetails + '</td></tr>' +
            '<tr><th>Status</th><td class="capitalize">' + taskStatus.replace(/\W+/, ' ') + '</td></tr>' +
            '<tr><th>Created By</th><td>' + createdByName + '</td></tr>' +
            '<tr><th>Created On</th><td>' + t.created_on + '</td></tr>' +
            '<tr><th>Modified On</th><td>' + t.modified_on + '</td></tr>' +
            '</table></div></div><hr />' +
            '<div class="row"><div class="col-md-12"><h5>Notes</h5><div class="well well-sm">' + t.notes + '</div></div></div></div>';

        taskHtml = taskHtmlHeader + taskHtmlBody;

        return '<div class="row record collapsed ' + taskStatus + '">' + taskHtml + '</div>';
    },

    getLeadHtmlFromTask: function(task) {
        if (! task.lead_id) {
            return '<em>No lead specified</em>';
        }

        var leadHtml = UserReport.getLeadLinkFromTask(task);

        var leadEmailAddress = '';
        if (task.email) {
            leadEmailAddress = '<a href="mailto:' + task.email + '">' + task.email + '</a>';
        }

        leadHtml += '<p><table class="table table-bordered table-striped well"><tbody>';
        leadHtml += '<tr><th>Email Address</th><td>' + leadEmailAddress + '</td></tr>';
        leadHtml += '<tr><th>Phone</th><td>' + (task.phone ? task.phone : '')  + '</td></tr>';
        leadHtml += '<tr><th>Cell Phone</th><td>' + (task.phone_cell ? task.phone_cell : '')  + '</td></tr>';
        leadHtml += '</tbody></table></p>';

        return leadHtml;
    },

    getLeadLinkFromTask: function(task) {
        if (! task.lead_id) {
            return '<em>No lead specified</em>';
        }

        var leadName = ((task.f_name ? task.f_name : '') + ' ' + (task.l_name ? task.l_name : '')).trim();
        if (! leadName.length) {
            leadName = '<em>Unnamed Lead</em>';
        }

        return '<a href="/lead/view/' + task.lead_id + '">' + leadName + '</a>';
    },

    attachEventsToRows: function() {
        $('button.expand').off('click').on('click', function() {
            $(this).toggleClass('dropup').parentsUntil('#rows').toggleClass('collapsed');
        });

        $('.row.record h4').off('dblclick').on('dblclick', function() {
            $(this).parentsUntil('#rows').find('button.expand').trigger('click');
        });
    },

    updatePagination: function(totalDisplayedTasks) {
        if (UserReport.currentPage < 1) {
            $('ul.pagination li.previous').addClass('disabled').off('click');
        } else {
            $('ul.pagination li.previous').removeClass('disabled').off('click').on('click', function() {
                UserReport.currentPage--;
                UserReport.renderRows();
            });
        }

        if (UserReport.currentPage+1 >= UserReport.getTotalPageCount()) {
            $('ul.pagination li.next').addClass('disabled').off('click');
        } else {
            $('ul.pagination li.next').removeClass('disabled').off('click').on('click', function() {
                UserReport.currentPage++;
                UserReport.renderRows();
            });
        }

        if (UserReport.getTotalPageCount() === 1) {
            $('ul.pagination li.current-page').addClass('disabled').off('click');
        } else {
            $('ul.pagination li.current-page').removeClass('disabled').off('click').on('click', function() {
                var pageNumber = prompt('Jump to a page number', '');
                pageNumber = parseInt(pageNumber) - 1;

                if (isNaN(pageNumber) || pageNumber < 0 || pageNumber >= UserReport.getTotalPageCount()) {
                    return false;
                }

                UserReport.currentPage = pageNumber < 0 ? 0 : pageNumber;
                UserReport.renderRows();
            });
        }

        var paginationDisplay = (UserReport.currentPage + 1) + ' / ' + UserReport.getTotalPageCount();
        $('ul.pagination li.current-page .number').text(paginationDisplay);
    },

    renderGraph: function() {
        var range = this.getTimeRange();
        var min = range.min;
        var max = range.max;

        var subdivisions = 5;
        var secondsInAYear = 31557600;

        var displayFormat = 'M/DD';
        var showYear = moment($('#endTime').val()).unix() - moment($('#startTime').val()).unix() >= secondsInAYear;

        if (showYear) {
            // Include the year if we're looking over a range of a year or more
            subdivisions = 4;
            displayFormat = 'M/DD/YY h:mm';
        } else if ((max-min) <= 86400) {
            // Display times with date if we're within a single day
            displayFormat = 'M/DD h:mm';
        }

        var plotPoints = UserReport.buildPlotPoints(min, max, subdivisions, displayFormat);
        UserReport.renderPlotPoints(plotPoints);
    },

    buildPlotPoints: function(rangeMin, rangeMax, subdivisions, displayFormat) {
        var plotPoints = [];
        var division = Math.ceil((rangeMax-rangeMin+1) / subdivisions);

        var divisions = {};
        for (var i=0; i<subdivisions; i++) {
            var key = division * i + rangeMin;
            divisions[key] = 0;
        }

        var tasks = UserReport.getFilteredTasks();

        for (var i in tasks) {
            var time = moment(tasks[i].created_on).unix();

            for (var k in divisions) {
                var divisionTime = parseInt(k);
                if (time >= divisionTime && time < divisionTime + division) {
                    divisions[k]++;
                    break;
                }
            }
        }

        for (var key in divisions) {
            plotPoints.push([
                moment.unix(parseInt(key)).format(displayFormat) + ' - ' + moment.unix(parseInt(key) + division).format(displayFormat),
                divisions[key]
            ]);
        }

        return plotPoints;
    },

    renderPlotPoints: function(plotPoints) {
        $.plot('#graph', [ {data: plotPoints, color: '#00acac'} ], {
            series: {
                bars: {
                    show: true,
                    barWidth: 0.4,
                    align: 'center',
                    fill: true,
                    fillColor: '#00acac',
                    zero: true
                }
            },
            xaxis: {
                tickColor: '#ddd',
                tickLength: 0,
                mode: 'categories',
                labelAngle: 90
            },
            yaxis: {
                minTickSize: 1,
                tickDecimals: 0
            },
            grid: {
                borderWidth: 0
            }
        });
    },

    getTimeRange: function() {
        var min = 0;
        var max = 0;

        var tasks = UserReport.getFilteredTasks();

        for (var i=1; i<this.tasks.length; i++) {

            var time = moment(this.tasks[i].created_on).unix();

            if (min === 0 || time < min) {
                min = time;
            }

            if (max === 0 || time > max) {
                max = time;
            }
        }

        return { min: min, max: max };
    },

    stringToDatetime: function(str) {
        return str.replace(/^(\d{2})\/(\d{2})\/(\d{4})$/, "$3-$1-$2 00:00:00");
    },

    datetimeToString: function(str) {
        return str.replace(/^(\d{4})-(\d{2})-(\d{2}) \d{2}:\d{2}:\d{2}$/, "$2/$3/$1");
    },

    generateCsv: function() {
        var rows = [
            '"Task Id","Lead Name","Lead Email","Lead Phone","Lead Cell","Lead Note","Task Assigned To","Task Created Date","Task Created Timestamp","Task Completed Date","Task Completed By"'
        ];

        var tasks = UserReport.getFilteredTasks();

        for (var i in tasks) {
            var t = tasks[i];

            var taskLine = [
                t.id,
                ((t.f_name ? t.f_name : '') + ' ' + (t.l_name ? t.l_name : '')).trim(),
                t.email,
                t.phone,
                t.phone_cell,
                t.notes,
                ((t.assigned_to_f_name ? t.assigned_to_f_name : '') + ' ' + (t.assigned_to_l_name ? t.assigned_to_l_name : '')).trim(),
                t.created_on,
                moment(t.created_on).unix() + '',
                t.completed == '1' ? t.modified_on : '',
                t.completed == '1' ? ((t.assigned_to_f_name ? t.assigned_to_f_name : '') + ' ' + (t.assigned_to_l_name ? t.assigned_to_l_name : '')).trim() : ''
            ];

            var row = [];

            for (var j in taskLine) {
                // Replace line breaks and newlines with semicolons, remove HTML tags otherwise
                var escapedLine = taskLine[j] ? taskLine[j].replace(/(\s*(<br[^>]*>\s*|\n)\s*)+/ig, '; ').replace(/<\/?[^>]*>|^\s*;?\s*|\s*;?\s*$/g, '') : '';
                // Escape double quotes
                escapedLine = '"' + escapedLine.replace('"', '""') + '"';

                row.push(escapedLine);
            }

            rows.push(row);
        }

        return rows.join("\n");
    },

    downloadCsv: function() {
        if (! this.getFilteredTasks().length) {
            alert('No data is available to generate a report from');
            return false;
        }

        var csvText = this.generateCsv();

        if (csvText.split("\n").length < 2) {
            alert('This report is empty. Please try adjusting your filters and time range before trying again');
            return false;
        }

        var filename = 'user-task-report-' +
            this.datetimeToString(this.startTime).replace(/\D/g, '') + '-' +
            this.datetimeToString(this.endTime).replace(/\D/g, '') + '.csv';

        var csvBlob = new Blob([csvText], {type: 'text/csv'});
        if (window.navigator.msSaveOrOpenBlob) {
            // Download through IE/Edge
            window.navigator.msSaveBlob(csvBlob, filename);
        } else {
            // Download through FF/Chrome/etc
            var element = window.document.createElement('a');
            element.href = window.URL.createObjectURL(csvBlob);
            element.download = filename;
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        }
    }
};